import { ClientState, updateActiveCompany } from '~/store/slices/client.slice';
import { CountryCode } from '~/enums';
import { useLocalStorage } from '@qred/components-library';
import { useDispatch, useSelector } from 'react-redux';
import { Language, RootState } from '~/store/types/sharedTypes';
import { Company } from '~/models/clients/company';
import {
  setLanguage as _setLanguage,
  setMarket as _setMarket,
} from '~/store/slices/intl.slice';
import { usePutClientInfoMutation } from '~/store/apis/endpoints/myPages/clients/clients.api';

interface UseClientReturn extends ClientState {
  setActiveCompany(company: Company): void;
  clearActiveCompanyId(): void;
  setMarket(market: CountryCode): void;
  setLanguage(language: Language): void;
  market: CountryCode;
  language: Language;
}

export const useClient = (): UseClientReturn => {
  const dispatch = useDispatch();
  const { market, language } = useSelector((state: RootState) => state.intl);
  const [putClientInfo] = usePutClientInfoMutation();

  const [
    _,
    setActiveCompanyIdLocalStorage,
    clearActiveCompanyIdLocalStorage,
  ] = useLocalStorage<number>({
    key: '@qred/activeCompanyId',
  });

  const state = useSelector((_state: RootState) => _state.client);

  const setMarket = (_market: CountryCode) => {
    dispatch(_setMarket(_market));
  };

  const setLanguage = (_language: Language) => {
    dispatch(_setLanguage(_language));
    putClientInfo({
      ...state.info,
      language: _language,
    });
  };

  const setActiveCompany = (company: Company) => {
    setActiveCompanyIdLocalStorage(company.id);
    dispatch(updateActiveCompany(company));
  };

  return {
    ...state,
    market,
    language,
    setMarket,
    setLanguage,
    setActiveCompany,
    clearActiveCompanyId: clearActiveCompanyIdLocalStorage,
  };
};
